import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { avatarChipTheme } from "./chipTheme";

interface AvatarWrapperProps {
    themeMode: RequiredThemeKeys;
}

export const AvatarWrapper = styled("div")<AvatarWrapperProps>(
    ({ themeMode }) => `
    display: inline-flex;
    align-items: center;
    padding-left: ${avatarChipTheme.avatar.padding.left(themeMode)};
`
);
